package com.bulut.mecitogullari.core.firebase

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.apps
import dev.gitlive.firebase.initialize

/**
 * Firebase bootstrap. The `FirebaseConfig` object itself is GENERATED at
 * build time from the `firebase.*` keys in local.properties (gitignored) —
 * see the `generateFirebaseConfig` task in shared/build.gradle.kts.
 */

/** Platform-specific [FirebaseOptions] (differs by App ID and API key). */
expect fun platformFirebaseOptions(): FirebaseOptions

/**
 * Initializes Firebase once. [platformContext] must be the Android
 * application context on Android; it is ignored elsewhere.
 */
fun initFirebase(platformContext: Any? = null) {
    if (Firebase.apps(platformContext).isNotEmpty()) return
    Firebase.initialize(platformContext, platformFirebaseOptions())
}
